import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SERVICES } from "@/lib/site";
import PageHero from "@/components/PageHero";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Services"
        title="What we build, repair, and oversee."
        subtitle="Six disciplines covering the full lifecycle of a construction project — from feasibility through to handover."
      />

      <section className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-24">
          {SERVICES.map((s, idx) => (
            <div
              key={s.slug}
              id={s.slug}
              className="grid lg:grid-cols-12 gap-10 items-center"
              data-testid={`service-section-${s.slug}`}
            >
              <div className={`lg:col-span-7 ${idx % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-[420px] object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>
              <div className={`lg:col-span-5 ${idx % 2 === 1 ? "lg:order-1" : ""}`}>
                <div className="text-xs font-mono text-[#D4AF37]">0{idx + 1} / 06</div>
                <h2 className="mt-2 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-[#0A1A36]">
                  {s.title}
                </h2>
                <p className="mt-4 text-slate-600 leading-relaxed">{s.description}</p>
                <ul className="mt-6 space-y-2.5">
                  {s.points.map((p, i) => (
                    <li key={i} className="flex items-start gap-2 text-slate-700">
                      <Check className="h-4 w-4 text-[#D4AF37] mt-1" />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/quote" data-testid={`service-quote-${s.slug}`} className="inline-block mt-8">
                  <Button className="rounded-none h-11 px-6 bg-[#0A1A36] hover:bg-[#0F2347] text-white font-bold uppercase tracking-wider ag-btn-hover">
                    Get a quote <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
